import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 20px;
  .line-progress-title {
    font-size: 18px;
    font-weight: 700;
    color: #354052;
  }

  .banner-button {
    cursor: pointer;
    border-radius: 10px;
    img {
      border-radius: 10px;
      width: 100%;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
`;

export const Col = styled.div`
  padding-right: 10px;
  padding-left: 10px;
  flex: ${({ size }) => (size ? `0 0 ${(size / 12) * 100}%` : "0 0 100%")};
  max-width: ${({ size }) => (size ? `${(size / 12) * 100}%` : "100%")};

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;
